import { Box } from '@xstyled/styled-components';
import { Article, ScreenContainer, Button } from "../../../../smooth-doc/smooth-doc/components";
import { Link } from "gatsby";
import notFoundImageURL from "../../../../smooth-doc/smooth-doc/images/404.png";
import * as React from 'react';
export default {
  Box,
  Article,
  ScreenContainer,
  Button,
  Link,
  notFoundImageURL,
  React
};